// origin 最多保存 64 个字符；保留文件末尾，避免扩展名被截掉。
export const normalizePhotoFileName = name => Array.from(name).slice(-64).join('');

export const normalizePhotoUploadData = data => {
  if (!data || typeof data.origin !== 'string') return data;
  return { ...data, origin: normalizePhotoFileName(data.origin) };
};

// 查重必须使用与实际保存一致的名称，不修改调用方的筛选对象。
export const normalizePhotoExistOptions = options => {
  if (!options || typeof options.key !== 'string') return options;
  try {
    const query = JSON.parse(options.key);
    if (!query || typeof query.origin !== 'string') return options;
    return { ...options, key: JSON.stringify(normalizePhotoUploadData(query)) };
  } catch (error) {
    return options;
  }
};



// WEBPACK FOOTER //
// ./src/util/photoFileName.js